import { mapActions, mapState } from 'vuex';
import { includes } from 'lodash';

export default {
  props: {
    submitted: {
      type: Boolean
    }
  },
  components: {},
  data() {
    return {
      applicationForm: {
        firstName: '',
        lastName: '',
        patronymic: '',
        code: '',
        email: '',
        phone: '+380',
        docType: '',
        consumerType: 'Квартира',
        tariff: 'Річний',
        paymentMethod: ['byReceipt'],
        eisCode: '56X',
        applicantInfo: '',
        city: '',
        street: '',
        building: '',
        flat: '',
        postCode: '',
      },
      showFlatSelect: true,
      privatePolicy: false,
      rules: {
        firstName: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
        ],
        lastName: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
        ],
        email: [
          { type: 'email', message: 'Введіть правильну адресу електронної пошти', trigger: 'blur', }
        ],
        patronymic: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
          {
            min: 8,
            max: 12,
            message: 'Довжина цього поля повина бути від 8 до 12 символів',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const phone = value.replace(/^\D+/g, '');
              if (value === '') {

                callback(
                  new Error(
                    'Будь ласка введіть номер телефону',
                  ),
                );
              } else if (
                !this.isCellPhone(value) ||
                phone.length < 10 ||
                phone.length > 12
              ) {

                callback(
                  new Error(
                    'Будь ласка введіть вірний номер телефону',
                  ),
                );
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        consumerType: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
        ],
        tariff: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
        ],
        paymentMethod: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
        ],
        eisCode: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
          {
            min: 16,
            max: 16,
            message: 'Довжина цього поля повина бути 16 символів',
            trigger: 'blur',
          },
        ],
        applicantInfo: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
        ],
        city: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
        ],
        street: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
        ],
        building: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
        ],
        postCode: [
          {
            required: true,
            message: "Поле обов'язкове до заповнення",
            trigger: 'blur',
          },
        ],
      },
      applicationCreating: false,
    };
  },
  computed: {
    ...mapState({
      villages: (state) => {
        const blackListVillages = [
          'Почапинці',
          'Забойки',
          'Домаморич',
          'Довжанка',
        ];
        return state.Dictionary.villages.filter(
          (vil) => !includes(blackListVillages, vil.CITY_UA)
        );
      },
      streets: (state) => state.Dictionary.streets,
      buildings: (state) => state.Dictionary.buildings,
    }),
  },
  watch: {
    'applicationForm.consumerType': {
      handler(value) {

        value === 'Квартира' ? this.showFlatSelect = true : this.showFlatSelect = false;

      },
      deep: true,
    }
  },
  methods: {
    ...mapActions([
      'createApplication',
      'setApplicationData',
      'loadVillages',
      'loadStreets',
      'loadBuildings',
      'setApplicationBlob',
    ]),
    async sendApplication() {
      this.applicationCreating = true;
      this.$refs.applicationForm.validate((valid) => {
        if (valid) {
          this.applicationForm.source = window.location.host;
          this.createApplication(this.applicationForm)
            .then((resp) => {
              fetch(resp.data)
                .then((response) => response.blob())
                .then((blob) => {
                  this.setApplicationBlob(blob);
                  this.applicationCreating = false;
                });
              this.setApplicationData(this.applicationForm);
              this.$notify.success({
                title: 'Вітаємо!',
                message: 'Ваша заявка успішно створена.',
              });
              this.$emit('update:submitted', true);
            })
            .catch((error) => {
              this.$notify.error({
                title: 'Error',
                message: error.res.data,
              });
              this.applicationCreating = false;
            });
        } else {
          this.applicationCreating = false;
          return false;
        }
      });
    },
    onVillageChange(value) {
      this.loadStreets({
        cityId: value.CITY_ID,
        districtId: value.DISTRICT_ID,
      });
      this.applicationForm.city = value.CITY_UA;
      this.applicationForm.street = '';
      this.applicationForm.building = '';
      this.applicationForm.postCode = '';
    },
    onStreetChange(value) {
      this.applicationForm.street = value.STREET_UA;
      this.loadBuildings(value.STREET_ID);
      this.applicationForm.building = '';
      this.applicationForm.postCode = '';
    },
    onBuildingChange(value) {
      this.applicationForm.building = value?.HOUSENUMBER_UA || value;
      this.applicationForm.postCode = value.POSTCODE;
    },
    isCellPhone(val) {
      return !!/^(\+{0,})(\d{0,})(\s?[(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm.test(
        val,
      );
    },
  },
  beforeMount() {
    this.loadVillages();
  },
};
